import styled from 'styled-components';

import { device } from '../../../components/styles/MediaQuery';

export const ScPersonalPageContainer = styled.div<{ isReversed: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (${device.mobile}) {
    grid-template-columns: repeat(1, 1fr);
  }

  & .right {
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (${device.mobile}) {
      grid-row: ${({ isReversed }) => (isReversed ? 1 : 0)};
    }
  }
`;

export const ScProfileTitle = styled.p`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.02em;
  text-align: center;
  margin-bottom: 24px;
`;

export const ScLoyaltyStatusLine = styled.p`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.01em;
  flex-wrap: wrap;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  & .toggle-description {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    font-weight: 400;
    flex: 1 1 100%;
    margin-top: 24px;
  }

  & span {
    white-space: nowrap;
  }
`;

export const ScProfileContainer = styled.div`
  padding: 24px 16px;
  border-radius: 16px;
  background: ${({ theme }) => theme.color1};

  & .progress-bar {
    margin: 24px 0;
  }

  & .fields-container {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }

  & .button-container {
    min-width: 240px;
    max-width: max-content;
    margin: 0 auto;

    @media (${device.mobile}) {
      max-width: none;
    }
  }
`;

export const ScProfileFormContainer = styled(ScProfileContainer)`
  & .submit-container {
    min-width: 240px;
    max-width: max-content;
    width: 100%;
    margin: 0 auto;
    margin-top: 24px;
  }
`;

export const ScFullNameRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;

  @media (${device.mobile}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ScAddressRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;

  @media (${device.mobile}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ScFormNotification = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.color7};
  color: ${({ theme }) => theme.color3};
  padding: 16px;
  border-radius: 12px;
  margin: 24px 0;

  & .icon {
    min-width: 24px;
  }

  & .message {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.01em;
    padding-left: 16px;
  }
`;

export const ScEmailContainer = styled.div<{ confirmed: boolean }>`
  display: grid;
  grid-template-columns: ${({ confirmed }) =>
    `repeat(${confirmed ? 1 : 2}, auto)`};
  gap: 8px;
  margin-bottom: 16px;

  @media (${device.mobile}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
